/* eslint-disable no-alert */
import { Builder } from '@builder.io/react';

import TextBlock from './index.tsx';

Builder.registerComponent(TextBlock, {
  name: 'TextBlock',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Title'
    },
    {
      name: 'subtitle',
      type: 'string',
      defaultValue: 'Subtitle'
    },
    {
      name: 'overtitle',
      type: 'string',
      defaultValue: 'overtitle'
    },
    {
      name: 'text',
      type: 'richText'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: [
        'bg-transparent',
        'bg-neutral-950',
        'bg-neutral-900',
        'bg-neutral-100',
        'bg-neutral-800',
        'bg-[#050505]'
      ]
    },
    {
      name: 'paddingTop',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'paddingBottom',
      type: 'boolean',
      defaultValue: true
    }
  ]
});
